import { ToastErrorPayload, ToastSuccessPayload } from "@/types/snackbar";
import { get, set } from "@/utils/vuex";

interface State {
  isVisible: boolean;
  color: string;
  timer: number;
  message: string;
  icon: string;
}

export default {
  namespaced: true,
  state: (): State => ({
    isVisible: false,
    color: "info",
    timer: 5000,
    message: "",
    icon: "mdi-info",
  }),
  mutations: {
    setVisibility: set("isVisible"),
    toastSuccess: (state: State, payload: ToastSuccessPayload): void => {
      const { message } = payload;
      state.message = message;
      state.color = "success";
      state.icon = "mdi-check";
      state.isVisible = true;
    },
    toastError: (state: State, payload: ToastErrorPayload): void => {
      const { message, code, error } = payload;
      state.message = message || error || code || "error";
      state.color = "error";
      state.icon = "mdi-alert-circle-outline";
      state.isVisible = true;
    },
  },
  getters: {
    getVisibility: get("isVisible"),
    getColor: get("color"),
    getTimer: get("timer"),
    getMessage: get("message"),
    getIcon: get("icon"),
  },
};
